import React, { useEffect } from 'react';
import Modal from '../../../../Components/Modal/Modal';
import { Button, Input } from '../../../../Components/StyledComponents';
import CreateMenu from './CreateMenu';
import ReactDragListView from 'react-drag-listview';
import './MenuInfo.scss';
import { Slide } from '@mui/material';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { convertCost, languageText } from '../../../../Utils/functions';
import { alertRef } from '../../../../App';
import ModifyMenu from './ModifyMenu';

const MenuInfo = () => {
    const [isDrag, setIsDrag] = React.useState(false)
    const [list, setList] = React.useState([])
    const [data, setData] = React.useState({})
    const [groupName, setGroupName] = React.useState('')
    const modalRef = React.useRef(null);
    const modalModRef = React.useRef(null);

    const { menuGroupId } = useParams();

    useEffect(() => {
        getMenuInfo()
    }, [])

    const getMenuInfo = () => {
        axios.get('/api/pickup/order/menu/' + menuGroupId)
            .then((data) => {
                setList(data.data.MenuInfo)
                setGroupName(languageText(data.data.Name))
            })
    }

    const createMenu = (val) => {
        axios.post('/api/pickup/order/menu/' + menuGroupId, val)
            .then((data) => {
                if (data.status === 204) {
                    getMenuInfo()
                    modalRef.current.closeModal();
                    alertRef.current.showAlert({ title: '메뉴가 생성 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const patchMenu = (val) => {
        axios.patch('/api/pickup/order/menu/' + menuGroupId, val)
            .then((data) => {
                if (data.status === 204) {
                    getMenuInfo()
                    modalModRef.current.closeModal();
                    alertRef.current.showAlert({ title: '메뉴가 수정 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const removeMenu = (id) => {
        axios.delete('/api/pickup/order/menu/' + menuGroupId + '/' + id)
            .then((data) => {
                if (data.status === 204) {
                    getMenuInfo()
                    alertRef.current.showAlert({ title: '메뉴가 삭제 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const patchMenuOrder = () => {
        let arr = [];
        for (let i = 0; i < list.length; i++) {
            arr.push(list[i]._id.$oid)
        }

        axios.patch('/api/pickup/order/menu/group/menu/re_order', {
            GroupId: menuGroupId,
            MenuIds: arr
        })
            .then((data) => {
                if (data.status === 204) {
                    getMenuInfo()
                    setIsDrag(false)
                    alertRef.current.showAlert({ title: '메뉴 순서가 변경 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const showHideMenu = (id, isHide) => {
        let cond_text = '숨김'
        if(isHide) cond_text = '숨김해제'
    
        alertRef.current.showAlert({
            title: `정말 메뉴를 ${cond_text} 처리 하시겠어요?`,
            isConfirm: true,
            confirmText: '확인',
            isCancel: true,
            cancelText: '취소',
            onConfirm: () => {
                alertRef.current.hideAlert();

                axios.patch('/api/pickup/order/menu/hide/' + menuGroupId + '/' + id)
                .then((data) => {
                    if (data.status === 204) {
                        getMenuInfo()
                        modalModRef.current.closeModal();
                        alertRef.current.showAlert({ title: `메뉴가 ${cond_text} 처리 되었어요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                    }
                })
                .catch(() => {
                    alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                })
            }
        })
    }

    const dragProps = {
        onDragEnd(fromIndex, toIndex) {
            if (!isDrag) return;
            const data = [...list];
            const item = data.splice(fromIndex, 1)[0];
            data.splice(toIndex, 0, item);
            setList([...data]);
        },
        nodeSelector: 'li',
        handleSelector: 'div',
        lineClassName: 'line',
    };

    return (
        <div className='menu-info'>
            <div className='header-row'>
                <div className='row' style={{ alignItems: 'center', cursor: 'pointer' }} onClick={() => window.history.back()}>
                    <img src={require('../../../../aseets/icons/menu-back-arrow.svg').default} style={{ width: 32, height: 32, marginRight: 24 }} />
                    <p className='header' style={{ fontSize: 24 }}>{groupName}</p>
                </div>

                <div className='row'>
                    <Button variant="sub" small style={{ marginRight: 8, width: 112 }} onClick={() => setIsDrag(old => !old)}>
                        {isDrag ? '취소' : '순서변경'}
                    </Button>

                    {
                        isDrag ?
                            <Button variant="main" small style={{ width: 112 }} onClick={() => patchMenuOrder()}>
                                순서 저장
                            </Button>
                            :
                            <Button variant="main" small style={{ width: 112 }} onClick={() => modalRef.current.openModal()}>
                                메뉴 추가
                            </Button>
                    }
                </div>
            </div>

            <ReactDragListView {...dragProps}>
                <ol style={{ margin: 0, padding: 0 }}>
                    {
                        list.map((data, i) => {
                            return (
                                <li key={i}>
                                    <div className='divider'></div>
                                    <div className='menu-box'>
                                        <div className='row'>
                                            <Slide direction='right' in={isDrag} mountOnEnter unmountOnExit style={{ transitionDuration: '0.4s', transitionDelay: '0.2s' }}>
                                                <p className='move-icon' style={{ width: isDrag ? 24 : 0, transition: 'all', transitionDuration: '0.2s', }}>
                                                    <div style={{cursor: 'pointer'}}>
                                                        <img src={require('../../../../aseets/icons/menu-drag.svg').default} style={{ width: 24, height: 24, pointerEvents: 'none' }} />
                                                    </div>
                                                </p>
                                            </Slide>
                                            {
                                                data.Img !== '' &&
                                                <img src={"https://cdn.syrupfriends.com/Images/Menu/" + data.Img} className='menu-img' style={{ width: isDrag ? 0 : 100, height: isDrag ? 0 : 100, opacity: isDrag ? 0 : 1, left: isDrag ? -10 : 0, transition: 'all', transitionDuration: '0.5s' }} />
                                            }
                                            <div style={{ marginLeft: data.Img === '' ? 40 : 0 }}>
                                                <p className='menu-name'>{languageText(data.Name)}</p>
                                                <div style={isDrag ? { display: 'none' } : { marginTop: 4 }}>
                                                    {
                                                        data.Price.map((item, i) => {
                                                            return <p key={i} className='menu-desc'>{languageText(item.Name)} : {convertCost(item.Price)}원</p>
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row' style={{ alignItems: 'center', justifyContent: 'center', height: isDrag ? 0 : 'fit-content', opacity: isDrag ? 0 : 1, transition: 'all', transitionDuration: '0.5s' }}>
                                            {
                                                (typeof(data.isHide) === 'undefined' || !data.isHide) ? (
                                                    <button className='hide-btn' onClick={() => {showHideMenu(data._id.$oid, data.isHide)}}>
                                                        숨기기
                                                    </button>
                                                ) : (
                                                    <button className='show-btn' onClick={() => {showHideMenu(data._id.$oid, data.isHide)}}>
                                                        숨기기 해제
                                                    </button>
                                                )
                                            }
                                            <button className='mod-btn' onClick={() => {setData(data); modalModRef.current.openModal()}}>
                                                수정하기
                                            </button>
                                            <button className='remove-btn' onClick={() => alertRef.current.showAlert({ title: `정말 메뉴를 삭제하시겠어요?`, isConfirm: true, confirmText: '삭제', isCancel: true, cancelText: '취소', onConfirm: () => { alertRef.current.hideAlert(); removeMenu(data._id.$oid) } })}>
                                                <img src={require('../../../../aseets/icons/delete.svg').default} style={{ width: 24, height: 24 }} />
                                            </button>
                                        </div>
                                    </div>
                                </li>
                            )
                        })
                    }
                </ol>
            </ReactDragListView>

            <Modal isHeader title='메뉴 추가' ref={modalRef} contentContainer={{ width: 500, maxHeight: '80%', overflow: 'scroll' }} onBackdropClick={null}>
                <CreateMenu createMenu={createMenu} />
            </Modal>

            <Modal isHeader title='메뉴 수정' ref={modalModRef} contentContainer={{ width: 500, maxHeight: '80%', overflow: 'scroll' }} onBackdropClick={null}>
                <ModifyMenu info={data} patchMenu={patchMenu} />
            </Modal>
        </div>
    )
}

export default MenuInfo;